import { PositionKind } from '../chunk-IDUDVJCB.js';
import '../chunk-ZQHH67DQ.js';
import '../chunk-SFM26LZW.js';
import { ADDRESS_DEFAULT_PAGE_LIMIT, ADDRESS_MAX_PAGE_LIMIT, isContractType } from '../chunk-LFINYFZE.js';
export { ADDRESS_DEFAULT_PAGE_LIMIT, ADDRESS_ENRICHMENT_STATUSES, ADDRESS_FIELD_DEFAULTS, ADDRESS_LIST_MODES, ADDRESS_MAX_PAGE_LIMIT, ADDRESS_ROW_SCOPES, ADDRESS_ROW_SCOPE_DESCRIPTIONS, ADDRESS_ROW_SCOPE_LABELS, ADDRESS_SCOPES, ADDRESS_TYPES, ADDRESS_TYPE_LABEL, MAX_BULK_MEMBERS, addressRowScopeDescription, addressRowScopeLabel, hasRecordedView, isBeingMapped, isContractType, isDefaultedField, isUnconfirmedPresence, isVerified, showsRecordedValue } from '../chunk-LFINYFZE.js';
import { isPoolRole } from '../chunk-LON6RMEV.js';
import { scopeReadQuery } from '../chunk-KDST3WXS.js';
import '../chunk-6XJKVJAV.js';
import '../chunk-6V6OWGS3.js';
import '../chunk-MY2WTNZQ.js';
import '../chunk-VJNKQD5Y.js';
import '../chunk-3KBLIIIM.js';
import '../chunk-XR6TNFQL.js';
import { customerText } from '../chunk-EE3BFQYH.js';
import { unwrapData } from '../chunk-HIWBYL4O.js';
import '../chunk-F2PPQZ6W.js';
import '../chunk-X34AGPO3.js';
import '../chunk-QZC2D6M4.js';
import '../chunk-7B3IWQPL.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-HCZGW64N.js';
import '../chunk-WE6BFAVT.js';
import '../chunk-2FJIJRTO.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-DQNP4KXT.js';
import '../chunk-WVLHT3DL.js';
import '../chunk-42XBNXEN.js';
import '../chunk-7LLNC7LJ.js';
import '../chunk-BJ3WKLB6.js';
import '../chunk-INX63VAT.js';
import '../chunk-ONYSE4M6.js';
import { Severity, CatalogLifecycle, worstRisk } from '../chunk-UDOQQOJI.js';
import '../chunk-3QN2VZ56.js';
import '../chunk-PTQRMHJA.js';
import '../chunk-LUKPH4OM.js';
import '../chunk-O2TUCS6S.js';
import { nativeTokenMeta, str, num, normalizeAddress } from '../chunk-3PIYBOLI.js';
import '../chunk-NQUH7NWL.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-42RHM7UK.js';
import { toChainSlug } from '../chunk-LKQ6GCAX.js';
import '../chunk-GPJ572YS.js';
import { brandClass } from '../chunk-N7SZ66QO.js';
import '../chunk-RAO7SHWG.js';
import '../chunk-SAW4RQG7.js';
import '../chunk-PZ5AY32C.js';

// src/addresses/wallet-data.ts
function describeWalletReadGap(gap, { subject, chainName }) {
  const notNone = "This is not a statement that none are held.";
  if (Array.isArray(gap.providers) && gap.providers.length === 0 && gap.reason !== "refused") {
    return {
      title: `${capitalise(subject)} aren't read on ${chainName}`,
      description: `${capitalise(subject)} are not supported here on ${chainName}. ${notNone}`
    };
  }
  switch (gap.reason) {
    case "refused":
      return {
        title: `${capitalise(subject)} exceed the supported wallet size`,
        description: `This wallet holds too many tokens to show its ${subject} on ${chainName}. ${notNone}`
      };
    case "unsupported_chain":
      return {
        title: `${capitalise(subject)} aren't available on ${chainName}`,
        description: `${capitalise(subject)} are not supported here on ${chainName}. ${notNone}`
      };
    case "rate_limited":
      return {
        title: `${capitalise(subject)} couldn't be read right now`,
        description: `Updates are temporarily limited. Try again shortly. ${notNone}`
      };
    case "quarantined":
      return {
        title: `${capitalise(subject)} couldn't be read right now`,
        description: `Updates are temporarily paused. Try again in a few minutes. ${notNone}`
      };
    default:
      return {
        title: `${capitalise(subject)} couldn't be read`,
        description: `${capitalise(subject)} are temporarily unavailable for this address on ${chainName}. ${notNone}`
      };
  }
}
function capitalise(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
var enc = encodeURIComponent;
var walletDataPaths = {
  defi: (chain, address) => `/addresses/${enc(chain)}/${enc(address)}/defi`,
  balances: (chain, address) => `/addresses/${enc(chain)}/${enc(address)}/balances`,
  nfts: (chain, address) => `/addresses/${enc(chain)}/${enc(address)}/nfts`,
  nftCollection: (chain, address) => `/addresses/${enc(chain)}/${enc(address)}/nft-collection`,
  domain: (chain, address) => `/addresses/${enc(chain)}/${enc(address)}/domain`
};
function numOrUndef(v) {
  if (v == null) return void 0;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n) ? n : void 0;
}
function defiKindFromLabel(label) {
  const l = (label ?? "").toLowerCase();
  if (/stak/.test(l)) return PositionKind.STAKE;
  if (/borrow|debt|loan/.test(l)) return PositionKind.BORROW;
  if (/suppl|lend|lent|deposit/.test(l)) return PositionKind.SUPPLY;
  if (/liquidity|pool|\blp\b/.test(l)) return PositionKind.LIQUIDITY;
  if (/farm|yield/.test(l)) return PositionKind.FARM;
  if (/vault/.test(l)) return PositionKind.VAULT;
  return PositionKind.OTHER;
}
function tokenToAsset(token, chainId) {
  return {
    symbol: token.symbol ?? token.name ?? "?",
    address: token.contract_address ?? void 0,
    chainId,
    amount: numOrUndef(token.balance_formatted),
    amountRaw: token.balance ?? void 0,
    decimals: token.decimals ?? void 0,
    priceUsd: token.usd_price ?? null,
    usdValue: token.usd_value ?? null,
    logoUrl: token.logo ?? token.thumbnail ?? null,
    ...legBucket(token.token_type) === "receipt" ? { receipt: true } : {}
  };
}
function legBucket(tokenType) {
  const t = (tokenType ?? "").trim().toLowerCase();
  if (!t) return "supplied";
  if (t === "defi-token" || t.includes("receipt")) return "receipt";
  if (t.includes("borrow") || t.includes("debt") || t.includes("loan")) return "borrowed";
  if (t.includes("reward") || t.includes("claimable") || t.includes("unclaimed")) return "rewards";
  return "supplied";
}
function legsByBucket(tokens, chainId) {
  const supplied = [];
  const borrowed = [];
  const rewards = [];
  for (const token of tokens) {
    const asset = tokenToAsset(token, chainId);
    const bucket = legBucket(token.token_type);
    if (bucket === "borrowed") borrowed.push(asset);
    else if (bucket === "rewards") rewards.push(asset);
    else supplied.push(asset);
  }
  return {
    ...supplied.length ? { supplied } : {},
    ...borrowed.length ? { borrowed } : {},
    ...rewards.length ? { rewards } : {}
  };
}
function walletDefiToPositions(defi, chainId) {
  const out = [];
  for (const proto of defi.protocols ?? []) {
    const protocolId = (proto.protocol_id ?? proto.protocol_name ?? "unknown").toLowerCase();
    (proto.positions ?? []).forEach((pos, i) => {
      out.push({
        id: `${pos.address ?? protocolId}-${i}`,
        protocolId,
        chainId,
        kind: defiKindFromLabel(pos.label),
        label: pos.label ?? proto.protocol_name ?? void 0,
        ...legsByBucket(pos.tokens ?? [], chainId),
        tvlUsd: pos.balance_usd ?? null,
        netUsd: pos.balance_usd ?? null,
        source: customerText("moralis"),
        metadata: {
          protocol_name: proto.protocol_name ?? void 0,
          protocol_logo: proto.protocol_logo ?? void 0,
          protocol_url: proto.protocol_url ?? void 0
        }
      });
    });
  }
  return out;
}
function walletDefiIsEmpty(defi) {
  if (!defi) return true;
  return !(defi.protocols ?? []).some((p) => (p.positions ?? []).length > 0);
}
function walletBalanceRows(balances, chainId) {
  const tokens = [...balances?.tokens ?? []];
  const native = balances?.native?.balance;
  if (native != null && native !== "" && !tokens.some((t) => t.native_token)) {
    const meta = nativeTokenMeta(chainId ?? balances?.chain);
    tokens.unshift({
      symbol: meta.symbol ?? null,
      decimals: meta.decimals ?? null,
      balance: String(native),
      usd_price: balances?.native?.usd_price ?? null,
      usd_value: balances?.native?.usd_value ?? null,
      native_token: true
    });
  }
  return tokens;
}
function partitionWalletBalances(balances, chainId) {
  const held = [];
  const spam = [];
  for (const token of walletBalanceRows(balances, chainId)) (token.possible_spam ? spam : held).push(token);
  const byValue = (a, b) => Number(Boolean(b.native_token)) - Number(Boolean(a.native_token)) || (b.usd_value ?? -1) - (a.usd_value ?? -1);
  return { held: held.sort(byValue), spam: spam.sort(byValue) };
}
function walletBalancesOutcome(balances, chainId) {
  if (!balances) return "unread";
  if (walletBalanceRows(balances, chainId).length > 0) return "held";
  if (balances.tokens == null) return "unread";
  return balances.native && balances.native.balance == null ? "unread" : "empty";
}
function walletBalancesGap(balances) {
  return balances?.tokens_unavailable ?? balances?.native?.unavailable ?? null;
}
function walletBalancesIsEmpty(balances, chainId) {
  return walletBalancesOutcome(balances, chainId) !== "held";
}
function partitionWalletNfts(page) {
  const held = [];
  const spam = [];
  for (const item of page?.items ?? []) (item.possible_spam ? spam : held).push(item);
  return { held, spam };
}
function walletNftPageIsEmpty(page) {
  return !page || (page.items ?? []).length === 0;
}
function mergeWalletNftPages(previous, next) {
  if (!previous) return next;
  const seen = new Set(
    (previous.items ?? []).map((i) => `${i.token_address ?? ""}:${i.token_id ?? ""}`)
  );
  const added = (next.items ?? []).filter(
    (i) => !seen.has(`${i.token_address ?? ""}:${i.token_id ?? ""}`)
  );
  return { ...next, items: [...previous.items ?? [], ...added] };
}
function walletNftItemToDto(item, chainId) {
  const meta = item.metadata_parsed ?? {};
  const collection = (item.token_address ?? "").toLowerCase();
  const metaName = typeof meta.name === "string" ? meta.name : null;
  const metaImage = typeof meta.image === "string" ? meta.image : null;
  const metaDesc = typeof meta.description === "string" ? meta.description : null;
  return {
    org_id: "main",
    tenant_id: "main",
    org_id_tenant_id: "main-main",
    customer_id: null,
    customer_org_tenant_pk_v2: "",
    chain_id: chainId,
    family: "evm",
    collection,
    token_id: item.token_id ?? "",
    owner: item.owner_of ?? null,
    name: item.name ?? metaName,
    description: metaDesc,
    image_uri: metaImage,
    metadata_uri: item.token_uri ?? null,
    collection_info: null,
    supply: item.amount ?? null,
    source: customerText("moralis"),
    metadata: {
      ...meta,
      rarity_rank: item.rarity_rank,
      rarity_percentage: item.rarity_percentage,
      rarity_label: item.rarity_label,
      floor_price_usd: item.floor_price_usd,
      possible_spam: item.possible_spam,
      verified_collection: item.verified_collection,
      list_price: item.list_price
    },
    chain_id_collection: `${chainId}#${collection}`
  };
}
function walletNftsToDtos(page, chainId) {
  return (page.items ?? []).map((item) => walletNftItemToDto(item, chainId));
}
function nftCollectionViewToCollection(view) {
  return {
    address: view.contract_address,
    name: view.name ?? null,
    symbol: view.symbol ?? null,
    isVerified: view.verified_collection ?? false,
    logoUrl: view.collection_logo ?? null,
    floorPriceUsd: view.floor_price_usd ?? null
  };
}

// src/addresses/helpers.ts
var PROTECTED_FIELDS = /* @__PURE__ */ new Set([
  "chain",
  "address",
  "customer_id",
  "org_id",
  "tenant_id",
  "org_id_tenant_id",
  "customer_org_tenant_pk_v2",
  "id",
  "created_at",
  "created_by",
  "created_by_service",
  "updated_at",
  "updated_by",
  "updated_by_service"
]);
function addressRefPath(chain, address) {
  return `addresses/${encodeURIComponent(chain)}/${encodeURIComponent(address)}`;
}
function clampAddressLimit(limit) {
  if (limit == null || Number.isNaN(limit)) return ADDRESS_DEFAULT_PAGE_LIMIT;
  return Math.max(1, Math.min(Math.trunc(limit), ADDRESS_MAX_PAGE_LIMIT));
}
function addressEditableBody(fields) {
  const out = {};
  for (const [k, v] of Object.entries(fields)) {
    if (PROTECTED_FIELDS.has(k)) continue;
    if (v === void 0) continue;
    out[k] = v;
  }
  return out;
}
function existingPrimaryChains(rows, address) {
  const target = (address ?? "").trim().toLowerCase();
  if (!target) return [];
  const seen = /* @__PURE__ */ new Set();
  for (const r of rows) {
    if (!r?.is_primary_chain) continue;
    if (String(r.address ?? "").trim().toLowerCase() !== target) continue;
    const chain = String(r.chain ?? "").trim();
    if (chain) seen.add(chain);
  }
  return [...seen];
}
function isContractLike(row) {
  if (!row) return false;
  if (row.is_contract != null) return row.is_contract === true;
  return isContractType(str(row.address_type));
}
var EOA_ADDRESS_TYPES = /* @__PURE__ */ new Set(["wallet", "eoa"]);
function isKnownNonContract(row) {
  if (!row) return false;
  if (row.is_contract === false) return true;
  if (row.is_contract === true) return false;
  return EOA_ADDRESS_TYPES.has(str(row.address_type) ?? "");
}
function addressColorOf(row) {
  const meta = row?.metadata;
  return str(meta?.color);
}
function addressTypeFromRoles(roles) {
  for (const raw of roles ?? []) {
    const role = str(raw);
    if (role && isPoolRole(role)) return { type: "dex_pool", role };
  }
  return void 0;
}
function addressLogoKeyOf(row) {
  return str(row?.logo_s3_uri);
}
function summarizeActivity(activity) {
  if (!activity) {
    return {
      activeChains: 0,
      totalTx: 0,
      totalDefi: 0,
      totalNft: 0,
      totalTokenTransfers: 0
    };
  }
  const chainCount = activity.active_chain_ids?.length || Object.keys(activity.chains ?? {}).length;
  return {
    activeChains: chainCount,
    totalTx: activity.total_tx_count ?? 0,
    totalDefi: activity.total_defi_count ?? 0,
    totalNft: activity.total_nft_count ?? 0,
    totalTokenTransfers: activity.total_token_transfer_count ?? 0,
    firstSeenAt: activity.first_seen_at ?? null,
    lastSeenAt: activity.last_seen_at ?? null
  };
}

// src/addresses/labels.ts
var SEVERITY_LABEL = {
  [Severity.INFO]: "Informational",
  [Severity.LOW]: "Low",
  [Severity.MEDIUM]: "Medium",
  [Severity.HIGH]: "High",
  [Severity.CRITICAL]: "Critical"
};
var LIFECYCLE_LABEL = {
  [CatalogLifecycle.VERIFIED]: "Verified",
  [CatalogLifecycle.CANDIDATE]: "Awaiting review",
  [CatalogLifecycle.DEPRECATED]: "Deprecated",
  [CatalogLifecycle.QUARANTINED]: "Quarantined"
};
function severityLabel(value) {
  return SEVERITY_LABEL[String(value ?? "")] ?? titleCase(value);
}
function lifecycleLabel(value) {
  return LIFECYCLE_LABEL[String(value ?? "")] ?? titleCase(value);
}
function approvalLabel(isHumanApproved) {
  return isHumanApproved === true ? "Confirmed by a person" : void 0;
}
var SOURCE_LABEL = {
  manual: "Entered by an operator",
  user: "Entered by an operator",
  reconciler: "Address reconciler",
  enrichment: "Enrichment pipeline",
  internal: "Internal data",
  provider: "Third-party provider",
  system: "Platform default",
  // What the read boundary sends an external caller instead of provider names
  // (`commons.evidence.models.EXTERNAL_SOURCE_LABEL`).
  "aggregated from multiple sources": "Aggregated from multiple sources",
  aggregate: "Aggregated from multiple sources"
};
function sourceLabel(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return void 0;
  return customerText(SOURCE_LABEL[raw.toLowerCase()] ?? raw);
}
function titleCase(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  return raw.replace(/[_-]+/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

// src/addresses/rollup.ts
function groupAddressesByAddress(rows, { fallbackChain = "eth" } = {}) {
  const groups = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const key2 = str(row.address);
    if (!key2) continue;
    const bucket = groups.get(key2);
    if (bucket) bucket.push(row);
    else groups.set(key2, [row]);
  }
  const out = [];
  for (const [address, groupRows] of groups) {
    const primaryChains = /* @__PURE__ */ new Set();
    const typeSet = /* @__PURE__ */ new Set();
    let name;
    let lastSeenAt;
    let color;
    let logoKey;
    for (const r of groupRows) {
      const chain = str(r.chain);
      if (chain && r.is_primary_chain) primaryChains.add(chain);
      const type = str(r.address_type);
      if (type && type !== "unknown") typeSet.add(type);
      if (!name) name = str(r.name);
      const rowColor = addressColorOf(r);
      if (rowColor && (color == null || r.is_primary_chain)) color = rowColor;
      const rowLogo = addressLogoKeyOf(r);
      if (rowLogo && (logoKey == null || r.is_primary_chain)) logoKey = rowLogo;
      const seen = num(r.last_seen_at);
      if (seen != null && (lastSeenAt == null || seen > lastSeenAt)) lastSeenAt = seen;
    }
    const chains = [
      ...new Set(groupRows.map((r) => str(r.chain)).filter((c) => Boolean(c)))
    ].sort((a, b) => Number(primaryChains.has(b)) - Number(primaryChains.has(a)));
    const riskLevel = worstRisk(groupRows.map((r) => r.risk_level));
    out.push({
      address,
      rows: groupRows,
      chains,
      primaryChains: [...primaryChains],
      ...name ? { name } : {},
      types: [...typeSet],
      ...riskLevel ? { riskLevel } : {},
      ...lastSeenAt != null ? { lastSeenAt } : {},
      ...color ? { color } : {},
      ...logoKey ? { logoKey } : {},
      preferredChain: chains.find((c) => primaryChains.has(c)) ?? chains[0] ?? fallbackChain
    });
  }
  out.sort((a, b) => (b.lastSeenAt ?? 0) - (a.lastSeenAt ?? 0));
  return out;
}

// src/addresses/roles.ts
var MEMBERSHIP_ROLE_SUGGESTIONS = [
  {
    value: "treasury",
    label: "Treasury",
    hint: "Holds the company's own funds \u2014 the default for a corporate wallet."
  },
  {
    value: "hot_wallet",
    label: "Hot wallet",
    hint: "Operational, keys online: pays out, sweeps in, moves often."
  },
  {
    value: "cold_wallet",
    label: "Cold wallet",
    hint: "Long-term custody, keys offline: rarely moves, large balances."
  },
  {
    value: "multisig",
    label: "Multisig",
    hint: "Held behind several signers (a Safe, a custodian's vault): approvals before it moves."
  },
  {
    value: "deposit",
    label: "Deposit address",
    hint: "Receives from customers or counterparties; one of very many."
  },
  {
    value: "withdrawal",
    label: "Withdrawal",
    hint: "Pays out to customers or counterparties \u2014 the outbound twin of a deposit address."
  },
  {
    value: "settlement",
    label: "Settlement",
    hint: "Nets off with a counterparty, exchange or market maker."
  },
  {
    value: "payroll",
    label: "Payroll",
    hint: "Pays people or contractors on a schedule."
  },
  {
    value: "contract_deployer",
    label: "Deployer",
    hint: "The EOA that deployed the entity's contracts."
  },
  {
    value: "contract",
    label: "Contract",
    hint: "A contract the entity operates (the address itself is code)."
  },
  {
    value: "bridge",
    label: "Bridge",
    hint: "Moves the entity's funds between chains."
  },
  {
    value: "fee",
    label: "Fee collector",
    hint: "Accrues protocol or trading fees."
  },
  {
    value: "personal",
    label: "Personal wallet",
    hint: "One person's own wallet inside your organization \u2014 map it to their unit, privately."
  }
];
var MEMBERSHIP_ROLE_VALUES = MEMBERSHIP_ROLE_SUGGESTIONS.map((r) => r.value);
function membershipRoleSuggestion(role) {
  const needle = normalizeRole(role);
  if (!needle) return void 0;
  return MEMBERSHIP_ROLE_SUGGESTIONS.find(
    (r) => normalizeRole(r.value) === needle || normalizeRole(r.label) === needle
  );
}
function membershipRoleLabel(role) {
  if (!role) return "";
  return membershipRoleSuggestion(role)?.label ?? PLATFORM_ROLE_LABEL[normalizeRole(role)] ?? role;
}
var PLATFORM_ROLE_LABEL = {
  dexpool: "DEX pool",
  liquiditypool: "Liquidity pool"
};
function normalizeRole(role) {
  return (role ?? "").trim().toLowerCase().replace(/[\s_-]+/g, "");
}

// src/addresses/matrix.ts
var canonicalChain = (chain) => toChainSlug(chain) ?? chain.trim();
var key = (chain, address) => `${canonicalChain(chain)}|${normalizeAddress(address, chain)}`;
function factChain(fact) {
  const row = fact;
  return String(row.chain ?? row.chain_id ?? "");
}
function membershipMatrix({
  memberships,
  chains,
  facts,
  primaryByChain = {}
}) {
  const factByKey = /* @__PURE__ */ new Map();
  for (const fact of facts ?? []) {
    const row = fact;
    if (!row.address) continue;
    factByKey.set(key(factChain(fact), row.address), row);
  }
  const columns = [];
  const columnByChain = /* @__PURE__ */ new Map();
  const addColumn = (chain) => {
    if (!chain) return;
    const id = canonicalChain(chain);
    if (columnByChain.has(id)) return;
    columnByChain.set(id, chain);
    columns.push(chain);
  };
  if (chains) for (const chain of chains) addColumn(chain);
  const primaryByCanonicalChain = /* @__PURE__ */ new Map();
  for (const [chain, address] of Object.entries(primaryByChain)) {
    if (address) primaryByCanonicalChain.set(canonicalChain(chain), normalizeAddress(address, chain));
  }
  const rowByAddress = /* @__PURE__ */ new Map();
  for (const m of memberships) {
    const address = m.address;
    const chain = m.chain;
    if (!address || !chain) continue;
    if (!chains) addColumn(chain);
    const column = columnByChain.get(canonicalChain(chain));
    if (!column) continue;
    const lower = normalizeAddress(address, chain);
    let row = rowByAddress.get(lower);
    if (!row) {
      row = { address, cells: {} };
      rowByAddress.set(lower, row);
    }
    const fact = factByKey.get(key(chain, address));
    row.name = row.name ?? fact?.name ?? null;
    row.cells[column] = {
      state: primaryByCanonicalChain.get(canonicalChain(chain)) === lower ? "primary" : "member",
      known: fact ? fact.known ?? true : void 0,
      isContract: fact?.is_contract ?? null,
      addressType: fact?.address_type ?? null,
      role: m.role ?? null,
      tier: m.tier ?? null,
      active: m.active ?? void 0
    };
  }
  for (const [chain, address] of Object.entries(primaryByChain)) {
    if (!address) continue;
    const column = columnByChain.get(canonicalChain(chain));
    if (!column) continue;
    const lower = normalizeAddress(address, chain);
    let row = rowByAddress.get(lower);
    if (!row) {
      row = { address, cells: {} };
      rowByAddress.set(lower, row);
    }
    if (row.cells[column]) continue;
    const fact = factByKey.get(key(column, address));
    row.name = row.name ?? fact?.name ?? null;
    row.cells[column] = {
      state: "primary",
      known: fact ? fact.known ?? true : void 0,
      isContract: fact?.is_contract ?? null,
      addressType: fact?.address_type ?? null
    };
  }
  const rows = [];
  for (const row of rowByAddress.values()) {
    for (const chain of columns) {
      if (row.cells[chain]) continue;
      const fact = factByKey.get(key(chain, row.address));
      row.cells[chain] = {
        state: "none",
        known: fact ? fact.known ?? true : void 0,
        isContract: fact?.is_contract ?? null,
        addressType: fact?.address_type ?? null
      };
    }
    rows.push(row);
  }
  return { chains: columns, rows };
}
var MATRIX_ADDRESS_BUDGET = 100;
var MATRIX_FULL_LIMIT = 25;
var isDerived = (rows) => rows.length > 0 && rows.every((m) => m.tier === "derived");
var isCore = (rows) => rows.some((m) => m.tier === "core");
var isRetired = (rows) => rows.length > 0 && rows.every((m) => m.active === false);
function boundMatrixMemberships({
  memberships,
  primaryByChain = {},
  budget = MATRIX_ADDRESS_BUDGET,
  fullBelow = MATRIX_FULL_LIMIT
}) {
  const headlines = new Set(
    Object.entries(primaryByChain).filter(([, address]) => Boolean(address)).map(([chain, address]) => normalizeAddress(address, chain))
  );
  const byAddress = /* @__PURE__ */ new Map();
  for (const m of memberships) {
    if (!m.address || !m.chain) continue;
    const lower = normalizeAddress(m.address, m.chain);
    const rows = byAddress.get(lower);
    if (rows) rows.push(m);
    else byAddress.set(lower, [m]);
  }
  let unloadedHeadlines = 0;
  for (const address of headlines) if (!byAddress.has(address)) unloadedHeadlines += 1;
  const total = byAddress.size + unloadedHeadlines;
  const classified = [...byAddress.values()].some(
    (rows) => rows.some((m) => m.tier === "core" || m.tier === "derived")
  );
  if (total <= fullBelow && !classified) {
    return {
      memberships: [...byAddress.values()].flat(),
      shown: total,
      total,
      curated: false,
      classified: false
    };
  }
  const spansChains = (rows) => {
    const seen = /* @__PURE__ */ new Set();
    for (const m of rows) if (m.chain) seen.add(canonicalChain(m.chain));
    return seen.size > 1;
  };
  const rank = (address, rows) => {
    if (headlines.has(address)) return 0;
    if (isDerived(rows)) return null;
    if (isCore(rows)) return 1;
    return spansChains(rows) ? 2 : 3;
  };
  const earned = [...byAddress.entries()].map(([address, rows], order) => ({
    rows,
    rank: rank(address, rows),
    retired: isRetired(rows),
    order
  })).filter(
    (entry) => entry.rank !== null
  );
  const kept = earned.sort(
    (a, b) => a.rank - b.rank || Number(a.retired) - Number(b.retired) || a.order - b.order
  ).slice(0, budget);
  return {
    memberships: kept.flatMap((entry) => entry.rows),
    shown: kept.length + unloadedHeadlines,
    total,
    // The budget is a cap on legibility; the filter is a statement about what the
    // grid is for. Only the latter changes what the caller should say.
    curated: earned.length < byAddress.size,
    classified
  };
}

// src/addresses/api.ts
var MissingRouteError = class extends Error {
  constructor(path, envelope) {
    super(`route ${path} is not available on this backend (HTTP ${envelope.statusCode})`);
    this.path = path;
    this.name = "MissingRouteError";
    this.statusCode = envelope.statusCode;
  }
  path;
  static {
    brandClass(this, "addresses/MissingRouteError");
  }
  statusCode;
};
function isMissingRoute(res) {
  if (res.ok) return false;
  if (res.statusCode !== 403 && res.statusCode !== 404) return false;
  if (res.error?.error_code) return false;
  const message = (res.error?.message ?? "").toLowerCase();
  return message.includes("missing authentication token") || message.includes("not found") || message === "forbidden";
}
function createAddressesApi(client, options = {}) {
  const base = (options.basePath ?? "/addresses").replace(/\/+$/, "");
  const ref = (chain, address) => `${base}/${encodeURIComponent(chain)}/${encodeURIComponent(address)}`;
  const memberships = `${base}/entity-memberships`;
  return {
    async list(query, signal) {
      const q = {
        // The wire calls this `scope`; the domain calls it `mode`. THE one
        // translation — see `AddressListMode` for why the domain refuses the
        // word. It is not a tenancy rung and this route takes none.
        scope: query?.mode ?? "tenant",
        limit: clampAddressLimit(query?.limit)
      };
      if (query?.entity_id) q.entity_id = query.entity_id;
      const address = query?.address?.trim();
      if (address) q.address = address;
      if (query?.include_global) q.include_global = true;
      if (query?.cursor) q.cursor = query.cursor;
      if (query?.address_type) q.address_type = query.address_type;
      if (query?.chain_ids?.length) q.chain_ids = query.chain_ids.join(",");
      const page = unwrapData(await client.get(base, { query: q, signal, cacheTtlMs: 0 }));
      const unreadable = !Array.isArray(page?.addresses);
      const addresses = unreadable ? [] : page.addresses;
      return {
        addresses,
        next_cursor: page?.next_cursor ?? null,
        count: page?.count ?? addresses.length,
        ...unreadable ? { unreadable: true } : {}
      };
    },
    async get(chain, address, signal) {
      return unwrapData(await client.get(ref(chain, address), { signal, cacheTtlMs: 0 })).address;
    },
    async getDetail(chain, address, opts, signal) {
      const query = { ...scopeReadQuery(opts?.scope ?? null) };
      if (opts?.withScopes) query.scopes = true;
      const res = unwrapData(
        await client.get(ref(chain, address), { query, signal, cacheTtlMs: 0 })
      );
      return {
        address: res?.address,
        saved: res?.saved ?? false,
        enrichment_status: res?.enrichment_status ?? null,
        catalog: res?.catalog,
        other_scopes: Array.isArray(res?.other_scopes) ? res.other_scopes : [],
        own_override: res?.own_override ?? false,
        own_fields: Array.isArray(res?.own_fields) ? res.own_fields.filter((f) => typeof f === "string") : []
      };
    },
    async getByAddress(address, signal, options2) {
      const res = unwrapData(
        await client.get(base, {
          query: { scope: "cross_chain", address, ...options2?.discovery === false ? { discovery: "stored" } : {} },
          signal,
          cacheTtlMs: 0
        })
      );
      const addresses = (Array.isArray(res?.addresses) ? res.addresses : []).map((row) => ({
        ...row,
        saved: row?.saved ?? true,
        enrichment_status: row?.enrichment_status ?? null,
        // Defaults FALSE, unlike `saved`: claiming an annotation nobody made
        // would show a row's defaults as somebody's judgement.
        annotated: row?.annotated ?? false
      }));
      return {
        addresses,
        activity: res?.activity ?? null,
        count: res?.count ?? addresses.length,
        unchecked_chain_ids: Array.isArray(res?.unchecked_chain_ids) ? res.unchecked_chain_ids.filter((chain) => typeof chain === "string") : [],
        ...typeof res?.discovery_complete === "boolean" ? { discovery_complete: res.discovery_complete } : {}
      };
    },
    async create(input) {
      const { chain, address, ...rest } = input;
      const body = { chain, address, ...addressEditableBody(rest) };
      return unwrapData(await client.post(base, body)).address;
    },
    async createMany(input) {
      const body = {
        ...addressEditableBody(input.fields ?? {}),
        address: input.address
      };
      if (input.chains?.length) body.chains = input.chains;
      if (input.all_chains) body.all_chains = true;
      if (input.per_chain && Object.keys(input.per_chain).length > 0) {
        body.per_chain = Object.fromEntries(
          Object.entries(input.per_chain).map(([chain, fields]) => [
            chain,
            addressEditableBody(fields ?? {})
          ])
        );
      }
      if (input.assignments?.length) {
        body.assignments = input.assignments.map((a) => ({
          catalog_kind: a.catalog_kind,
          catalog_id: a.catalog_id,
          user_scoped: a.user_scoped ?? true,
          ...a.visible_to_user_ids ? { visible_to_user_ids: a.visible_to_user_ids } : {},
          ...a.visible_to_team_ids ? { visible_to_team_ids: a.visible_to_team_ids } : {}
        }));
      }
      if (input.set_primary_entity_id) {
        body.set_primary_entity_id = input.set_primary_entity_id;
        if (input.set_primary_rung && input.set_primary_rung !== "user") {
          body.set_primary_rung = input.set_primary_rung;
        }
      }
      const res = unwrapData(await client.post(base, body));
      return {
        results: Array.isArray(res?.results) ? res.results : [],
        addresses: Array.isArray(res?.addresses) ? res.addresses : [],
        count: res?.count ?? 0,
        failed: res?.failed ?? 0,
        overlays: Array.isArray(res?.overlays) ? res.overlays : [],
        primary: Array.isArray(res?.primary) ? res.primary : []
      };
    },
    async update(chain, address, changes) {
      return unwrapData(
        await client.patch(ref(chain, address), addressEditableBody(changes))
      ).address;
    },
    async remove(chain, address, scope = "user") {
      unwrapData(await client.delete(ref(chain, address), { query: { scope } }));
    },
    async getActivity(chain, address, signal) {
      const res = unwrapData(
        await client.get(`${ref(chain, address)}/activity`, {
          signal,
          cacheTtlMs: 0
        })
      );
      return res.activity ?? null;
    },
    async listAssignments(chain, address, signal) {
      const res = unwrapData(
        await client.get(`${ref(chain, address)}/assignments`, {
          signal,
          cacheTtlMs: 0
        })
      );
      return res.assignments ?? [];
    },
    async attachAssignment(chain, address, input) {
      const { user_scoped, ...rest } = input;
      return unwrapData(
        await client.post(`${ref(chain, address)}/assignments`, {
          ...rest,
          user_scoped: user_scoped ?? true
        })
      ).assignment;
    },
    async detachAssignment(chain, address, input) {
      unwrapData(
        await client.delete(`${ref(chain, address)}/assignments`, {
          query: {
            catalog_kind: input.catalog_kind,
            catalog_id: input.catalog_id,
            // Sent only when the caller MEANS one lane. Absent, the route clears
            // whichever partition holds the overlay — the private one or the
            // tenant-wide one. This used to default to `true`, which made every
            // detach of a tenant-wide overlay delete a key that did not exist:
            // a 200, an unchanged chip, and no way to remove it at all.
            ...input.user_scoped === void 0 ? {} : { user_scoped: input.user_scoped }
          }
        })
      );
    },
    async share(chain, address, input) {
      return unwrapData(
        await client.post(`${ref(chain, address)}/share`, {
          catalog_kind: input.catalog_kind,
          catalog_id: input.catalog_id,
          user_scoped: input.user_scoped ?? true,
          add_user_ids: input.add_user_ids,
          add_team_ids: input.add_team_ids,
          remove_user_ids: input.remove_user_ids,
          remove_team_ids: input.remove_team_ids
        })
      ).assignment;
    },
    async setPrimary(chain, address, entityId, options2 = {}) {
      return unwrapData(
        await client.put(`${ref(chain, address)}/primary`, {
          entity_id: entityId,
          ...options2.rung ? { rung: options2.rung } : {},
          ...options2.expectedVersion != null ? { expected_version: options2.expectedVersion } : {},
          // An explicit `null`, never an omission: an absent `address` is "the
          // one in the path", and conflating the two would set the headline the
          // operator meant to hide.
          ...options2.noAddress ? { address: null } : {}
        })
      ).primary;
    },
    async listPrimaryEntities(chain, address, signal) {
      const path = `${ref(chain, address)}/primary`;
      const res = await client.get(path, { signal, cacheTtlMs: 0 });
      if (res.ok) {
        const body = res.data ?? res.result;
        if (Array.isArray(body?.entity_ids)) return body.entity_ids.map(String).filter(Boolean);
        return (body?.primaries ?? []).map((row) => String(row?.scope_target_id ?? "")).filter(Boolean);
      }
      if (isMissingRoute(res)) throw new MissingRouteError(path, res);
      if (res.statusCode === 404) return [];
      unwrapData(res);
      return [];
    },
    async clearPrimary(chain, address, entityId, options2 = {}) {
      unwrapData(
        await client.delete(`${ref(chain, address)}/primary`, {
          query: { entity_id: entityId, ...options2.rung ? { rung: options2.rung } : {} }
        })
      );
    },
    async getEntityMapping(chain, address, signal) {
      const res = await client.get(`${ref(chain, address)}/entity`, {
        signal,
        cacheTtlMs: 0
      });
      if (res.ok) {
        const body = res.data ?? res.result;
        return body?.mapping ?? body?.mappings?.[0] ?? null;
      }
      if (isMissingRoute(res)) throw new MissingRouteError(`${ref(chain, address)}/entity`, res);
      if (res.statusCode === 404) return null;
      unwrapData(res);
      return null;
    },
    async putEntityMapping(chain, address, input) {
      return unwrapData(
        await client.put(`${ref(chain, address)}/entity`, {
          entity_id: input.entity_id,
          ...input.role !== void 0 ? { role: input.role } : {},
          ...input.tier !== void 0 ? { tier: input.tier } : {},
          ...input.confidence !== void 0 ? { confidence: input.confidence } : {},
          ...input.valid_from !== void 0 ? { valid_from: input.valid_from } : {},
          ...input.valid_to !== void 0 ? { valid_to: input.valid_to } : {},
          ...input.source !== void 0 ? { source: input.source } : {},
          ...input.metadata !== void 0 ? { metadata: input.metadata } : {}
        })
      ).mapping;
    },
    async listEntityMappings(chain, address, signal) {
      const res = await client.get(`${ref(chain, address)}/entity`, {
        signal,
        cacheTtlMs: 0
      });
      if (res.ok) {
        const body = res.data ?? res.result;
        if (Array.isArray(body?.mappings)) return body.mappings;
        return body?.mapping ? [body.mapping] : [];
      }
      if (res.statusCode === 404) return [];
      unwrapData(res);
      return [];
    },
    async deleteEntityMapping(chain, address, entityId) {
      unwrapData(
        await client.delete(`${ref(chain, address)}/entity`, {
          // Sent only when the caller means ONE mapping. Absent, the route
          // drains every entity mapped to this address for the tenant.
          query: entityId ? { entity_id: entityId } : void 0
        })
      );
    },
    async listEntityMemberships(query, signal) {
      const res = await client.get(memberships, {
        query: {
          entity_id: query.entity_id,
          limit: clampAddressLimit(query.limit),
          ...query.cursor ? { cursor: query.cursor } : {},
          ...query.chains?.length ? { chains: query.chains.join(",") } : {},
          ...query.prefer_core ? { core: "true" } : {},
          ...query.address_type ? { address_type: query.address_type } : {},
          // `chains` above widens the headline pointer's coverage; this narrows
          // the rows. Two parameters that both name chains, so they are spelled
          // apart on the wire as well as in the type.
          ...query.chain_ids?.length ? { chain_ids: query.chain_ids.join(",") } : {}
        },
        signal,
        cacheTtlMs: 0
      });
      if (!res.ok && isMissingRoute(res)) throw new MissingRouteError(memberships, res);
      const page = unwrapData(res);
      const mappings = Array.isArray(page?.mappings) ? page.mappings : [];
      const primary = page?.primary_by_chain;
      const total = page?.member_total;
      return {
        mappings,
        next_cursor: page?.next_cursor ?? null,
        count: page?.count ?? mappings.length,
        primary_by_chain: primary && typeof primary === "object" ? primary : {},
        member_total: typeof total === "number" ? total : null,
        // "all" on a deployment that predates the lanes, which is the honest
        // reading: it served the paged index, and a caller must not caption an
        // unlabelled page as a curated one.
        lane: page?.lane === "core" ? "core" : "all",
        truncated: page?.truncated === true
      };
    },
    async putEntityMemberships(input) {
      const res = await client.post(memberships, {
        entity_id: input.entity_id,
        members: input.members.map((m) => ({
          chain: m.chain,
          address: m.address,
          // Only forward what the caller SET: an explicit `undefined` would be
          // dropped by JSON, but an explicit `null` would override the batch
          // default with nothing.
          ...m.role !== void 0 ? { role: m.role } : {},
          ...m.tier !== void 0 ? { tier: m.tier } : {},
          ...m.confidence !== void 0 ? { confidence: m.confidence } : {},
          ...m.valid_from !== void 0 ? { valid_from: m.valid_from } : {},
          ...m.valid_to !== void 0 ? { valid_to: m.valid_to } : {}
        })),
        ...input.role !== void 0 ? { role: input.role } : {},
        ...input.tier !== void 0 ? { tier: input.tier } : {},
        ...input.confidence !== void 0 ? { confidence: input.confidence } : {},
        ...input.source !== void 0 ? { source: input.source } : {},
        ...input.metadata !== void 0 ? { metadata: input.metadata } : {}
      });
      if (!res.ok && isMissingRoute(res)) throw new MissingRouteError(memberships, res);
      const out = unwrapData(res);
      const results = Array.isArray(out?.results) ? out.results : [];
      return {
        results,
        count: out?.count ?? results.filter((r) => r.ok).length,
        failed: out?.failed ?? results.filter((r) => !r.ok).length,
        mappings: Array.isArray(out?.mappings) ? out.mappings : []
      };
    },
    async enrich(chain, address, signal) {
      const res = unwrapData(
        await client.get(`${ref(chain, address)}/3rd-parties`, {
          signal,
          cacheTtlMs: 0
        })
      );
      return res.activity ?? null;
    },
    async listWalletTransactions(chain, address, query, signal) {
      return unwrapData(
        await client.get(`${ref(chain, address)}/transactions`, {
          query: {
            ...query?.limit ? { limit: query.limit } : {},
            ...query?.cursor ? { cursor: query.cursor } : {}
          },
          signal,
          cacheTtlMs: 0
        })
      );
    },
    async getDefi(chain, address, query, signal) {
      return unwrapData(
        await client.get(`${ref(chain, address)}/defi`, {
          query: {
            ...query?.chain ? { chain: query.chain } : {},
            ...query?.protocol ? { protocol: query.protocol } : {}
          },
          signal,
          cacheTtlMs: 0
        })
      );
    },
    async getNfts(chain, address, query, signal) {
      return unwrapData(
        await client.get(`${ref(chain, address)}/nfts`, {
          query: {
            ...query?.limit ? { limit: query.limit } : {},
            ...query?.cursor ? { cursor: query.cursor } : {}
          },
          signal,
          cacheTtlMs: 0
        })
      );
    },
    async getNftCollection(chain, address, query, signal) {
      return unwrapData(
        await client.get(`${ref(chain, address)}/nft-collection`, {
          query: {
            ...query?.limit ? { limit: query.limit } : {},
            ...query?.cursor ? { cursor: query.cursor } : {}
          },
          signal,
          cacheTtlMs: 0
        })
      );
    },
    async getDomain(chain, address, signal) {
      return unwrapData(
        await client.get(`${ref(chain, address)}/domain`, {
          signal,
          cacheTtlMs: 0
        })
      );
    }
  };
}

export { LIFECYCLE_LABEL, MATRIX_ADDRESS_BUDGET, MATRIX_FULL_LIMIT, MEMBERSHIP_ROLE_SUGGESTIONS, MEMBERSHIP_ROLE_VALUES, MissingRouteError, SEVERITY_LABEL, addressColorOf, addressEditableBody, addressLogoKeyOf, addressRefPath, addressTypeFromRoles, approvalLabel, boundMatrixMemberships, clampAddressLimit, createAddressesApi, defiKindFromLabel, describeWalletReadGap, existingPrimaryChains, groupAddressesByAddress, isContractLike, isKnownNonContract, lifecycleLabel, membershipMatrix, membershipRoleLabel, membershipRoleSuggestion, mergeWalletNftPages, nftCollectionViewToCollection, partitionWalletBalances, partitionWalletNfts, severityLabel, sourceLabel, summarizeActivity, walletBalanceRows, walletBalancesGap, walletBalancesIsEmpty, walletBalancesOutcome, walletDataPaths, walletDefiIsEmpty, walletDefiToPositions, walletNftItemToDto, walletNftPageIsEmpty, walletNftsToDtos };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map